import React from 'react'
import Link from '@mui/material/Link';

export default function Footer(props) {
    return (
        <Link href={props.href} underline="none" 
            style={{
                // color: !props.href&&'black',                 
                // color: 'grey',                 
                color: 'rgba(97, 94, 94, 0.8)',                 
                wordBreak: 'break-word'}}>
            {props.children}
        </Link>
    )
}
